import React from 'react';
import { Route } from 'react-router-dom';
import styled from 'styled-components';
import logo from '../../assets/logo.png';

const StyledHeader = styled.div`
  /* margin-top: 10px; */
  margin-bottom: 10px;
  text-align: center;

  /* & > * {
    margin-bottom: 10px;
  } */
`;

const StyledSubjectHeading = styled.h4`
  margin-top: 30px;
`;

const StyledParagraph = styled.p`
  text-align: left;
`;

const Header = () => (
  <StyledHeader>
    <div>
      <img src={logo} alt='Logo' />
    </div>

    <h3>Dein Online-Buchungsportal</h3>

    <Route
      path={`/register/new`}
      render={() => (
        <StyledSubjectHeading>
          Registrierung einer neuen Organisation
        </StyledSubjectHeading>
      )}
    />

    <Route
      path={`/authentication/initiate-password-reset`}
      render={() => (
        <StyledParagraph>
          Gebe bitte deine E-Mail Adresse ein, um einen Link zum Zurücksetzen
          des Passworts zu erhalten.
        </StyledParagraph>
      )}
    />

    <Route
      path={`/authentication/reset-password`}
      render={() => (
        <StyledParagraph>
          Bitte gebe das von dir gewünschte neue Passwort zwei mal ein.
        </StyledParagraph>
      )}
    />
  </StyledHeader>
);

export default Header;
